module.exports = __webpack_public_path__ + "static/media/icon18.b35ed63d.png";